export default __webpack_public_path__ + "static/media/avatar_9.b2b0f5c7.svg";